












import { Vue, Prop, Component } from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag'
import InvoicePaymentCountry from '@/domain/billing/entity/invoice-payment-link/invoice-payment-country';

@Component({ components: { CountryFlag } })
export default class PaymentCountrySelection extends Vue {
  @Prop({ type: InvoicePaymentCountry, required: true })
  item!: InvoicePaymentCountry;
}
